export class BenchmarkSeriesItem
{
    public controlValue: string;
    public isOldControlValue: boolean;
    public isNewControlValue: boolean;
    public isEligibleAsForecast: boolean;
    public isCurrentlyEligibleAsForecast: boolean;
    public isSelectedAsForecast: boolean;

    public canStartMultiSelect: boolean;
    public canEndMultiSelect: boolean;
    public isMultiSelected: boolean;
}

export class BenchmarkSeries
{
    public name: string;
    public renamingName: string;
    public items: BenchmarkSeriesItem[];
    public isExclude: boolean;
    public renaming: boolean;
}

export class BenchmarkSeriesModel
{
    public series: BenchmarkSeries[];
    public oldControlValue: string;
    public newControlValue: string;
    public selectedSeriesName: string;
    public differentSeriesSelected: boolean;
    public previousSelectedSeries: string;
}